import { variants } from '../constants/variant'

const termsOfUseMap = {
  default: {
    lastUpdated: 'December 10, 2025',
    content: (
      <>
        <p>
          Welcome to our service. By accessing or using our website and services, you agree to be bound by these Terms of Use.
        </p>

        <h3 className="font-bold text-base mt-4">Acceptance of Terms</h3>
        <p>
          By using this service, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use.
        </p>

        <h3 className="font-bold text-base mt-4">Use of Service</h3>
        <p>
          You agree to use our service only for lawful purposes and in accordance with these Terms. 
          You may not use our service in any way that could damage, disable, or impair the service.
        </p>

        <h3 className="font-bold text-base mt-4">Intellectual Property</h3>
        <p>
          All content, features, and functionality of our service are owned by us or our licensors and are protected by copyright, 
          trademark, and other intellectual property laws.
        </p>

        <h3 className="font-bold text-base mt-4">Disclaimer</h3>
        <p>
          Our service is provided "as is" without warranties of any kind, either express or implied. 
          We do not warrant that the service will be uninterrupted or error-free.
        </p>

        <h3 className="font-bold text-base mt-4">Changes to Terms</h3>
        <p>
          We reserve the right to modify these Terms at any time. Your continued use of the service after changes 
          constitutes acceptance of the modified Terms.
        </p>
      </>
    )
  },
  avalon: {
    lastUpdated: 'December 23, 2025',
    content: (
      <>
        <p>
          These Terms of Service ("Terms") govern your access to and use of the website, products, and services 
          provided by SparX Inc ("SparX," "we," "us," or "our"). By accessing or using our Services, you agree 
          to be bound by these Terms. If you do not agree, do not use the Services.
        </p>

        <div className="mt-4 p-3 bg-gray-50 rounded">
          <p className="font-semibold mb-1">Company Information:</p>
          <p>SparX Inc</p>
          <p>1460 Broadway</p>
          <p>New York, NY 10036</p>
          <p>United States</p>
          <p>Email: info@sparx.ai</p>
        </div>

        <h3 className="font-bold text-base mt-6">1. Eligibility</h3>
        <p>
          You must be at least 18 years old to use our Services. By using the Services, you represent that you meet this requirement.
        </p>

        <h3 className="font-bold text-base mt-4">2. Use of Services</h3>
        <p>
          You agree to use the Services only for lawful business purposes and in compliance with all applicable laws and regulations.
          You may not misuse, interfere with, or attempt to disrupt the Services.
        </p>

        <h3 className="font-bold text-base mt-4">3. Intellectual Property</h3>
        <p>
          All content, software, designs, trademarks, and materials provided through the Services are owned by or licensed to SparX Inc.
          You may not copy, modify, distribute, or create derivative works without prior written consent.
        </p>

        <h3 className="font-bold text-base mt-4">4. User Submissions</h3>
        <p>
          Any information or materials you submit to SparX through contact forms or communications must be accurate and lawful.
          You grant SparX a non-exclusive right to use such information for business and service-related purposes.
        </p>

        <h3 className="font-bold text-base mt-4">5. Third-Party Services</h3>
        <p>
          Our Services may integrate or link to third-party services. SparX is not responsible for third-party content or practices.
        </p>

        <h3 className="font-bold text-base mt-4">6. Disclaimer of Warranties</h3>
        <p>
          The Services are provided "as is" and "as available" without warranties of any kind, express or implied.
          We do not guarantee uninterrupted or error-free operation.
        </p>

        <h3 className="font-bold text-base mt-4">7. Limitation of Liability</h3>
        <p>
          To the maximum extent permitted by law, SparX Inc shall not be liable for indirect, incidental, consequential, or punitive damages.
          Our total liability shall not exceed the amount paid to us, if any, for use of the Services.
        </p>

        <h3 className="font-bold text-base mt-4">8. Indemnification</h3>
        <p>
          You agree to indemnify and hold harmless SparX Inc from claims arising from your misuse of the Services or violation of these Terms.
        </p>

        <h3 className="font-bold text-base mt-4">9. Termination</h3>
        <p>
          We may suspend or terminate access to the Services at our discretion, without notice, for violations of these Terms.
        </p>

        <h3 className="font-bold text-base mt-4">10. Governing Law</h3>
        <p>
          These Terms are governed by the laws of the State of New York, without regard to conflict-of-law principles.
        </p>

        <h3 className="font-bold text-base mt-4">11. Changes to These Terms</h3>
        <p>
          We may update these Terms from time to time. Continued use of the Services constitutes acceptance of the updated Terms.
        </p>

        <h3 className="font-bold text-base mt-4">12. Contact Us</h3>
        <div className="mt-2">
          <p>Email: info@sparx.ai</p>
          <p className="mt-2">Mailing Address:</p>
          <p>SparX Inc</p>
          <p>1460 Broadway</p>
          <p>New York, NY 10036</p>
          <p>United States</p>
        </div>
      </>
    )
  }
}

export const termsOfUseVariantsMap = {
  [variants.df]: termsOfUseMap.default,
  [variants.ctf]: termsOfUseMap.default,
  [variants.sw]: termsOfUseMap.default,
  [variants.ew]: termsOfUseMap.default,
  [variants.pd]: termsOfUseMap.default,
  [variants.of]: termsOfUseMap.default,
  [variants.br]: termsOfUseMap.default,
  [variants.sf]: termsOfUseMap.default,
  [variants.ev]: termsOfUseMap.default,
  [variants.av]: termsOfUseMap.avalon,
}

export function getTermsOfUse(variant) {
  return termsOfUseVariantsMap[variant] || termsOfUseMap.default
}

